export default {
  SET_RECOMMEND_DVR_SERVERS(state, servers) {
    state.recommendDvrServers = servers;
  },
  SET_RECOMMEND_RESERVE_SERVERS(state, servers) {
    state.reserveDvrServers = servers;
  },
  SET_SERVER(state, server) {
    state.server = server;
  },
  SET_RECOMMENDED_PROXY_SERVERS(state, payload) {
    state.recommendedProxyServers = payload;
  },
  SET_MODES(state, modes) {
    state.modes = modes;
  },
  SET_RESERVE_TRANSFERS(state, reserveTransfers) {
    state.reserveTransfers = reserveTransfers;
  },
};
